import { DropdownOption } from "@benefitsui/app/lib/common.types";
import { RadioSelectData } from "@dxo/ng-swift-ui";
import { LeaveType } from "@benefitsui/app/shared/enums/leaveTypes";

export const stateList: DropdownOption<string>[] = [
  {key: "AL", displayName: "Alabama"},
	{key: "AK", displayName: "Alaska"},
	{key: "AZ", displayName: "Arizona"},
	{key: "AR", displayName: "Arkansas"},
	{key: "CA", displayName: "California"},
	{key: "CO", displayName: "Colorado"},
	{key: "CT", displayName: "Connecticut"},
	{key: "DE", displayName: "Delaware"},
	{key: "DC", displayName: "District Of Columbia"},
	{key: "FL", displayName: "Florida"},
	{key: "GA", displayName: "Georgia"},
	{key: "HI", displayName: "Hawaii"},
	{key: "ID", displayName: "Idaho"},
	{key: "IL", displayName: "Illinois"},
	{key: "IN", displayName: "Indiana"},
	{key: "IA", displayName: "Iowa"},
	{key: "KS", displayName: "Kansas"},
	{key: "KY", displayName: "Kentucky"},
	{key: "LA", displayName: "Louisiana"},
	{key: "ME", displayName: "Maine"},
	{key: "MD", displayName: "Maryland"},
	{key: "MA", displayName: "Massachusetts"},
	{key: "MI", displayName: "Michigan"},
	{key: "MN", displayName: "Minnesota"},
	{key: "MS", displayName: "Mississippi"},
	{key: "MO", displayName: "Missouri"},
	{key: "MT", displayName: "Montana"},
	{key: "NE", displayName: "Nebraska"},
	{key: "NV", displayName: "Nevada"},
	{key: "NH", displayName: "New Hampshire"},
	{key: "NJ", displayName: "New Jersey"},
	{key: "NM", displayName: "New Mexico"},
	{key: "NY", displayName: "New York"},
	{key: "NC", displayName: "North Carolina"},
	{key: "ND", displayName: "North Dakota"},
	{key: "OH", displayName: "Ohio"},
	{key: "OK", displayName: "Oklahoma"},
	{key: "OR", displayName: "Oregon"},
	{key: "PA", displayName: "Pennsylvania"},
	{key: "RI", displayName: "Rhode Island"},
	{key: "SC", displayName: "South Carolina"},
	{key: "SD", displayName: "South Dakota"},
	{key: "TN", displayName: "Tennessee"},
	{key: "TX", displayName: "Texas"},
	{key: "UT", displayName: "Utah"},
	{key: "VT", displayName: "Vermont"},
	{key: "VA", displayName: "Virginia"},
	{key: "WA", displayName: "Washington"},
	{key: "WV", displayName: "West Virginia"},
	{key: "WI", displayName: "Wisconsin"},
	{key: "WY", displayName: "Wyoming"},
  {key: "AS", displayName: "American Samoa"},
  {key: "GU", displayName: "Guam"},
  {key: "MP", displayName: "Northern Mariana Islands"},
  {key: "PR", displayName: "Puerto Rico"},
  {key: "UM", displayName: "United States Minor Outlying Islands"},
  {key: "VI", displayName: "Virgin Islands"},
  {key: "AA", displayName: "Armed Forces Americas"},
  {key: "AP", displayName: "Armed Forces Pacific"},
  {key: "AE", displayName: "Armed Forces Others"}
  ];

  const labels = {
    adoption: 'Adoption or foster care responsibilities',
    attendMilitaryEvent: 'Attend military event for a service member',
    bondingLeave: 'Bonding with a newborn or newly adopted child',
    deathADD: 'Death and/or AD&D',
    employeeIllness: 'Illness or illness-related surgery',
    employeeInjury: 'Injury or injury-related surgery',
    familyCare: 'Care for a family member',
    militaryCare: 'Care for a military service member',
    timeAway: 'Time away from work',
    other: 'Other (personal leave of absence)',
    ppl: 'Personal protected leave',
    pregnancy: 'Pregnancy'
  }

  //multiselect options
  export const claimTypeData: RadioSelectData[] = [
    { id: 'timeAway', name: 'timeAway', value: 'timeAway', label: labels.timeAway },
    { id: 'deathAD&D', name: 'deathAD&D', value: 'deathAD&D', label: labels.deathADD }
  ];

  export const timeAwayData: RadioSelectData[] = [
    {
      id: LeaveType.EmployeeIllness,
      name: LeaveType.EmployeeIllness,
      value: LeaveType.EmployeeIllness,
      label: labels.employeeIllness
    },
    {
      id: LeaveType.EmployeeInjury,
      name: LeaveType.EmployeeInjury,
      value: LeaveType.EmployeeInjury,
      label: labels.employeeInjury
    },
    {
      id: LeaveType.Pregnancy,
      name: LeaveType.Pregnancy,
      value: LeaveType.Pregnancy,
      label: labels.pregnancy
    },
    {
      id: LeaveType.FamilyCare,
      name: LeaveType.FamilyCare,
      value: LeaveType.FamilyCare,
      label: labels.familyCare
    },
    {
      id: LeaveType.BondingLeave,
      name: LeaveType.BondingLeave,
      value: LeaveType.BondingLeave,
      label: labels.bondingLeave
    },
    {
      id: LeaveType.Adoption,
      name: LeaveType.Adoption,
      value: LeaveType.Adoption,
      label: labels.adoption
    },
    {
      id: LeaveType.MilitaryCare,
      name: LeaveType.MilitaryCare,
      value: LeaveType.MilitaryCare,
      label: labels.militaryCare
    },
    {
      id: LeaveType.AttendMilitaryEvent,
      name: LeaveType.AttendMilitaryEvent,
      value: LeaveType.AttendMilitaryEvent,
      label: labels.attendMilitaryEvent
    },
    {
      id: LeaveType.PPL,
      name: LeaveType.PPL,
      value: LeaveType.PPL,
      label: labels.ppl
    },
    {
      id: LeaveType.Other,
      name: LeaveType.Other,
      value: LeaveType.Other,
      label: labels.other
    }
  ];